/**
 * This plug-in will get all cells from a selected row, returning
 * a DataTables API instance with selected cells
 *
 *  @name row().rowCells()
 *  @summary Get all cells from selected row
 *  @author bySabi Files
 *  @requires TupperTable 1.10+
 *
 * @returns {TupperTable} API instance with selected cells
 *
 *  @example
 *    // Get all cells from row 1
 *    var table = $('#example').DataTable();
 *    table.row( 1 ).rowCells();
 */

$.fn.dataTable.Api.register('row().rowCells()', function () {
    return this.cells(this.index(),this.columns()[0]);
});